import {WebFormModel} from "capitalist-shared/src/core/model";
import axios from "axios";
import {RemoteRequestState} from "capitalist-shared/src/core/remote";


export enum GenderEnum {
  Male = 'male',
  Female = 'female'
}

export class SupportReviewModel extends WebFormModel {

  submitStatus = new RemoteRequestState();
  checkStatus = new RemoteRequestState();

  values = {username: '', contacts: '', system: '', reason: '', id: '', rate: 5};

  checkId(reqid) {
    this.errors.clear();
    this.checkStatus.loadStart();
    return axios.post('/webapi/support/supportreview', {
      call: 'checkid',
      id: reqid
    }).then(result => {
      this.checkStatus.loadEnd();
      return result.data;
    }).catch(err => {
      this.checkStatus.loadError();
      throw err;
    });
  }

  sendReview() {
    this.submitStatus.loadStart();
    this.errors.clear();
    return axios.post('/webapi/support/supportreview', {
      call: 'post',
      m: this.values
    }).then(result => {
      this.submitStatus.loadEnd();
      return result.data.model;
    }).catch(err => {
      this.submitStatus.loadError();
      this.checkAxiosError(err);
      throw err;
    })
  }

  get systemOptions() {
    return {
      capitalist: 'ЛК Capitalist',
      telegram: 'Telegram',
      instagram: 'Instagram',
      facebook: 'Facebook',
      vk: 'vk.com',
      skype: 'Skype',
    }
  }
}
